import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const ADMIN_AUTH_CONFIG = { withCredentials: true };
const PRIMARY_API = `${BACKEND_URL}/api`;

const getSameOriginApi = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const sameOriginApi = `${window.location.origin}/api`;
  return sameOriginApi !== PRIMARY_API ? sameOriginApi : null;
};

const buildApiCandidates = () => {
  const sameOriginApi = getSameOriginApi();
  return sameOriginApi ? [PRIMARY_API, sameOriginApi] : [PRIMARY_API];
};

const postWithApiFallback = async (endpoint, payload = {}) => {
  const apiCandidates = buildApiCandidates();
  let lastError = null;

  for (const apiBase of apiCandidates) {
    try {
      return await axios.post(`${apiBase}${endpoint}`, payload, ADMIN_AUTH_CONFIG);
    } catch (error) {
      lastError = error;

      // Se o backend respondeu (401/500/etc), não tenta fallback para preservar comportamento.
      if (error.response) {
        throw error;
      }
    }
  }

  throw lastError;
};

export const adminLogin = (password) => postWithApiFallback('/admin/auth', { password: password.trim() });

export const adminVerify = () => postWithApiFallback('/admin/verify', {});

export const adminLogout = () => postWithApiFallback('/admin/logout', {});